<template>
    <div>
        <coach-availability-calendar :coach="coach" />
    </div>
</template>

<script>
export default {
    props: {
        coach: {
            type: Object,
            required: true
        }
    }
}
</script>
